import { Model } from 'modules/core/lib/mobx-rest'

export interface ILeaveHistory {
  id: number
  author_name: string | null
  author_id: number | null
  author_type: string | null
  leave_id: number
}

class LeaveHistory extends Model<ILeaveHistory> {
  static urlRoot() {
    return '/timeoff/leave_histories'
  }
}

export default LeaveHistory
